<mat-button-toggle-group (change)="onChange($event.value)"
                         [class.compact]="compact"
                         [class.flex-wrap]="!compact"
                         [class.gap-5]="!compact"
                         [class.mb-0]="compact"
                         [formControl]="control"
                         [hideSingleSelectionIndicator]="true"
                         class="customToggleGroup w-content">
    @for (option of options; track option) {
        <mat-button-toggle
                [style.background-color]="getColour(option.label, option.value)? getColour(option.label, option.value): null"
                [style.color]="this.themeService.getReadableColor(getColour(option.label, option.value))"
                [value]="option.value">
            @if (option.icon) {
                <mat-icon>{{ option.icon }}</mat-icon>
            }
            {{ option.label }}
        </mat-button-toggle>
    }
</mat-button-toggle-group>
